import { ReactElement } from 'react';

import { Atc } from '@dreryk/drerykweb-medicine-api';

import { Translate } from '@dreryk/react-common';
import { appendTestableElementAttributes, colorsMatrix } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { StyledAnxiolytic } from './Anxiolytic.styled';

const colorMap = (atc: Atc): string | null => {
   switch (atc) {
      case 'RPW':
      case 'ANXIOLYTIC_WITH_RPW':
         return colorsMatrix.purple.basic;
      case 'ANXIOLYTIC_WITHOUT_RPW':
         return colorsMatrix.green.basic;
      default:
         return null;
   }
};

const textMap = (atc: Atc): string | null => {
   switch (atc) {
      case 'RPW':
      case 'ANXIOLYTIC_WITH_RPW':
         return translationKeys.medicine.RPW;
      case 'ANXIOLYTIC_WITHOUT_RPW':
         return translationKeys.medicine.anxiolytic;
      default:
         return null;
   }
};

type AnxiolyticProps = {
   readonly anxiolytic: Atc;
};

export const Anxiolytic = (props: AnxiolyticProps): ReactElement | null => {
   const text = textMap(props.anxiolytic);
   const color = colorMap(props.anxiolytic);
   if (!text || !color) {
      return null;
   }

   return (
      <StyledAnxiolytic color={color} {...appendTestableElementAttributes('anxiolytic')}>
         <Translate>{text}</Translate>
      </StyledAnxiolytic>
   );
};
